export function isNumberEmpty(value) {
    return value && !Number.isNaN(value) && value.length === 0;
}

export function isTextEmpty(value) {
    if (Array.isArray(value)) {
        // Default value is an empty array
        return false;
    }
    return value.length === 0;
}

export function validerMonster(text, valideringsMonster) {
    try {
        return new RegExp(valideringsMonster).test(text);
    } catch (e) {
        return false;
    }
}
